import { memo } from "react";

import { AddToCartButtonPlaceholder } from "@components/Button/AddToCartButtonPlaceholder.view";
import { ProductComboOptionPlaceholder } from "@components/ProductComboOption/ProductComboOptionPlaceholder.view";
import { KlarnaPlaceholder } from "@react/sections/ProductHero/Klarna/KlarnaPlaceholder.view";
import { tw, type TTailwindString } from "classnames";

const styles = {
  base: tw(
    "border-0",
    "border-b",
    "border-solid",
    "border-placeholder",
    "pb-6",
    "md:border-b-0"
  ),
  productOptionTitle: tw(
    "mb-2.5",
    "flex",
    "h-5",
    "items-center",
    "gap-x-2",
    "text-primary",
    "md:mb-[11px]" as TTailwindString
  ),
  productOptionTitlePrimary: tw(
    "h-5",
    "w-full",
    "max-w-[100px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder"
  ),
  productOptionTitleSecondary: tw(
    "h-3",
    "w-full",
    "max-w-[100px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder"
  ),
  productComboOptions: tw("flex", "flex-col", "gap-y-4"),
  addToCart: tw("mt-6", "md:mt-10"),
};

const ProductSelectorPlaceholderBase = () => (
  <div className={styles.base} data-placeholder-region="component">
    <div
      className={tw(
        "mb-2",
        "gap-x-2",
        "border-0",
        "border-t",
        "border-solid",
        "border-placeholder",
        "pt-6"
      )}
    >
      {/* Product Option Title */}
      <div className={styles.productOptionTitle}>
        <div className={styles.productOptionTitlePrimary}></div>
        <div className={styles.productOptionTitleSecondary}></div>
      </div>

      {/* Product Combo Options */}
      <div className={styles.productComboOptions}>
        {/* Product Combo Active Option */}
        <ProductComboOptionPlaceholder isActive={true} />

        {/* Product Combo Inactive Option 1 */}
        <ProductComboOptionPlaceholder isActive={false} />

        {/* Product Combo Inactive Option 2 */}
        <ProductComboOptionPlaceholder isActive={false} />
      </div>

      {/* Product Hero Add to Cart */}
      <div className={styles.addToCart}>
        <AddToCartButtonPlaceholder />
      </div>

      {/* Product Hero Klarna */}
      <KlarnaPlaceholder />
    </div>
  </div>
);

export const ProductSelectorPlaceholder = memo(ProductSelectorPlaceholderBase);
